import { localize } from '../../../util/Localizer'

const createEmptyDentalClaimExpense = (hasCOB = false) => {
  return {
    ClaimLineId: null,
    ServiceDate: '',
    DentalInfo: {
      LaboratoryFees: 0,
      ProcedureCode: undefined,
      ProcedureFees: 0,
      ToothCode: '',
      ToothSurface: '',
      TotalCharges: 0
    },
    COBField: hasCOB ? { COBAmount: 0, originalTo: 'OC' } : null
  }
}

const createEmptyDentalClaimExpenseError = () => {
  return {
    ClaimLineId: '',
    ServiceDate: '',
    DentalInfo: {
      LaboratoryFees: '',
      ProcedureCode: '',
      ProcedureFees: '',
      ToothCode: '',
      ToothSurface: '',
      TotalCharges: ''
    },
    COBField: {
      COBAmount: ''
    }
  }
}

const createToothSurfaces = () => {
  return {
    V: false,
    O: false,
    L: false,
    D: false,
    M: false,
    I: false
  }
}

const validateToothCodeForDentalClaimExpense = (expense, error) => {
  let value = expense.DentalInfo.ToothCode
  let isValid = true

  if (!value) {
    isValid = false
    error.DentalInfo.ToothCode = localize('pages.SubmitAClaim.Expenses.Dental.ToothCodeError')
  } else if (value.length !== 2) {
    isValid = false
    error.DentalInfo.ToothCode = localize('pages.SubmitAClaim.Expenses.Dental.MinToothCodeError')
  }

  return isValid
}

const validateDateForDentalClaimExpense = (expense, error) => {
  // IMPORTANT: The current implementation of validateDateForDentalClaimExpense allows any string
  // of length greater than zero, except for 'N/A'. It should be updated to validate the
  // date string with a regex.
  const value = expense.ServiceDate
  const isValid = (typeof value === 'string' && value.length > 0 && value !== 'N/A')

  error.ServiceDate = (isValid) ? '' : localize('pages.SubmitAClaim.Expenses.ServiceDateValidation')

  return isValid
}

const validateProcedureCodeForDentalClaimExpense = (expense, error) => {
  const value = expense.DentalInfo.ProcedureCode
  let isValid = true

  if (!value) {
    isValid = false
    error.DentalInfo.ProcedureCode = localize('pages.SubmitAClaim.Expenses.Dental.ProcedureCodeError')
  } else if (value.length !== 5) {
    isValid = false
    error.DentalInfo.ProcedureCode = localize('pages.SubmitAClaim.Expenses.Dental.MinProcCodeError')
  }

  return isValid
}

const validateProcedureFeesForDentalClaimExpense = (expense, error) => {
  const value = Number(expense.DentalInfo.ProcedureFees)
  const isWithinLimit = (value <= 10000)
  const isValid = (!isNaN(value) && value > 0 && isWithinLimit)

  error.DentalInfo.ProcedureFees = (isValid) ? '' : (isWithinLimit) ? localize('pages.SubmitAClaim.Expenses.Dental.DentistsFeeError') : localize('pages.SubmitAClaim.Expenses.limitError')

  return isValid
}

const validateToothSurfacesForDentalClaimExpense = (expense, error, numSurfaces = 0) => {
  const value = expense.DentalInfo.ToothSurface
  const allowedNumSurfaces = expense.DentalInfo.numSurfaces || numSurfaces
  let isValid = true

  if (!value) {
    isValid = false
    error.DentalInfo.ToothSurface = localize('pages.SubmitAClaim.Expenses.Dental.ToothSurfacesError')
  } else if (value.length !== allowedNumSurfaces) {
    isValid = false
    error.DentalInfo.ToothSurface = localize('pages.SubmitAClaim.Expenses.Dental.ToothSurfacesNumberError')
  } else {
    isValid = true
    error.DentalInfo.ToothSurface = ''
  }
  return isValid
}

const validateLaboratoryFeesForDentalClaimExpense = (expense, error) => {
  // lab fee is allowed to be 0
  const value = Number(expense.DentalInfo.LaboratoryFees)
  const isWithinLimit = (value <= 10000)
  const isValid = (!isNaN(value) && value >= 0 && isWithinLimit)

  error.DentalInfo.LaboratoryFees = (isValid) ? '' : (isWithinLimit) ? localize('pages.SubmitAClaim.Expenses.Dental.LaboratoryFeeError') : localize('pages.SubmitAClaim.Expenses.limitError')

  return isValid
}

const validateOtherChargesForDentalClaimExpense = (expense, error) => {
  const value = expense.COBField
  let isValid = true
  if (!value || value.COBAmount === '') {
    isValid = false
    error.COBField.COBAmount = localize('pages.SubmitAClaim.Expenses.noCobError')
  } else if (Number(value.COBAmount) >= Number(expense.DentalInfo.ProcedureFees) + Number(expense.DentalInfo.LaboratoryFees)) {
    // this allows cob to equal 0, otherwise runs a check
    if (Number(value.COBAmount) === 0) {
      isValid = true
    } else {
      isValid = false
      error.COBField.COBAmount = localize('pages.SubmitAClaim.Expenses.cobValidation')
    }
  } else {
    error.COBField.COBAmount = ''
  }
  return isValid
}

export {
  createEmptyDentalClaimExpense,
  createEmptyDentalClaimExpenseError,
  createToothSurfaces,
  validateToothCodeForDentalClaimExpense,
  validateDateForDentalClaimExpense,
  validateProcedureCodeForDentalClaimExpense,
  validateProcedureFeesForDentalClaimExpense,
  validateToothSurfacesForDentalClaimExpense,
  validateLaboratoryFeesForDentalClaimExpense,
  validateOtherChargesForDentalClaimExpense
}



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/ManageDentalExpense/functions.js